export const readColor = (() => {
    return (data, index) => {
        let rgba = {
            r:null,
            g:null,
            b:null,
            a:null,
        };
        rgba.r = data[index    ];
        rgba.g = data[index + 1];
        rgba.b = data[index + 2];
        rgba.a = data[index + 3];
        return rgba;
    };
})();
